const registrationNumRegex = /^[A-Za-z]{2}-[0-9]{2}-([0-9]{4}$|[a-zA-Z]{1,3}-[0-9]{4})$/

const rtoNumRegex = /^[A-Za-z]{2}-[0-9]{2}$/

const mobileNumRegex = /^[6-9]{1}[0-9]{9}$/

const numberRegex = /^[0-9]*$/

const onlyAlphabetsRegex = /^[a-zA-Z]+$/

const alphaNumericRegex = /^[A-Z0-9]+$/

const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/

const emailRegex = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/

const panNumRegex = /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$/

const gstRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/


export {
  registrationNumRegex,
  mobileNumRegex,
  emailRegex,
  panNumRegex,
  numberRegex,
  alphaNumericRegex,
  ifscRegex,
  gstRegex,
  rtoNumRegex,
  onlyAlphabetsRegex,
}
